// extracted by mini-css-extract-plugin
module.exports = {"cover":"cover___2UWZT","coverEdit":"coverEdit___2PVSS"};